import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

interface AccountDescriptionProps {
  label?: string;
}

export const AccountDescription = ({ label = 'Account Description' }: AccountDescriptionProps) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Input {...formBag.register('AccountName')} label={label} maxLength={32} />
  );
};
